import * as i0 from '@angular/core';
import { EventEmitter, QueryList, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, ViewChild, ViewChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { SvgIcons } from '@niceltd/cxone-components/shared-services';
import * as i1 from '@angular/platform-browser';
import * as i3 from '@niceltd/cxone-components/resize-event';
import { ResizeEventModule } from '@niceltd/cxone-components/resize-event';
import * as i4 from 'ngx-bootstrap/popover';
import { PopoverModule } from 'ngx-bootstrap/popover';
import * as i5 from '@niceltd/cxone-components/translation';
import { TranslationModule } from '@niceltd/cxone-components/translation';
const _c0 = ["moreEleRef"];
const _c1 = ["tagWrapperEleRef"];
const _c2 = ["invisibleItemEleRef"];
function SelectedTagsComponent_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SelectedTagsComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SelectedTagsComponent_div_4_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.tagsHeaderTemplate);
  }
}
const _c3 = a0 => ({
  tag: a0
});
function SelectedTagsComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, item_r10));
  }
}
function SelectedTagsComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13, 14);
    i0.ɵɵlistener("click", function SelectedTagsComponent_div_6_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.viewMoreClicked.emit());
    });
    i0.ɵɵelementStart(2, "button", 15);
    i0.ɵɵlistener("onShown", function SelectedTagsComponent_div_6_Template_button_onShown_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.styleBackgroundColor());
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r8 = i0.ɵɵreference(11);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("popover", _r8)("containerClass", "cxone-selected-tags-popover custom-tags-class")("placement", "bottom")("outsideClick", true)("container", ctx_r3.popUpContainer);
    i0.ɵɵattribute("container", ctx_r3.popUpContainer)("aria-label", ctx_r3.hiddenItems.length + " " + i0.ɵɵpipeBind1(3, 9, "cxone-components.selectedTags.moreText"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r3.hiddenItems.length, " ", i0.ɵɵpipeBind1(5, 11, "cxone-components.selectedTags.moreText"), "");
  }
}
function SelectedTagsComponent_div_7_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 21);
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r17.svgIcons.getSvgIcons("icon-close"), i0.ɵɵsanitizeHtml);
  }
}
const _c4 = () => ({
  "background-color": "white",
  "height": "10px",
  "width": "10px",
  "margin-right": "5px"
});
function SelectedTagsComponent_div_7_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(1, _c4));
  }
}
function SelectedTagsComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16, 17);
    i0.ɵɵelement(2, "div", 18);
    i0.ɵɵtemplate(3, SelectedTagsComponent_div_7_button_3_Template, 1, 1, "button", 19)(4, SelectedTagsComponent_div_7_div_4_Template, 1, 2, "div", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("background-color", item_r15["color"]);
    i0.ɵɵproperty("innerText", item_r15[ctx_r4.label]);
    i0.ɵɵattribute("aria-label", item_r15[ctx_r4.label])("data-primary-value", item_r15[ctx_r4.primaryKey]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.removable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.hasSquareElement);
  }
}
const _c5 = a0 => ({
  "background-color": a0,
  "height": "10px",
  "width": "10px",
  "margin-right": "5px"
});
function SelectedTagsComponent_ng_template_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
  }
  if (rf & 2) {
    const tag_r19 = i0.ɵɵnextContext().tag;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c5, tag_r19.color));
  }
}
function SelectedTagsComponent_ng_template_8_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function SelectedTagsComponent_ng_template_8_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const tag_r19 = i0.ɵɵnextContext().tag;
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.removeItem(tag_r19));
    })("keydown.enter", function SelectedTagsComponent_ng_template_8_button_3_Template_button_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const tag_r19 = i0.ɵɵnextContext().tag;
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.removeItem(tag_r19));
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tag_r19 = i0.ɵɵnextContext().tag;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r21.svgIcons.getSvgIcons("icon-close"), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "cxone-components.selectedTags.remove") + tag_r19.text);
  }
}
const _c6 = a0 => ({
  "non-removable": a0
});
function SelectedTagsComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, SelectedTagsComponent_ng_template_8_div_1_Template, 1, 3, "div", 20);
    i0.ɵɵelement(2, "div", 24);
    i0.ɵɵtemplate(3, SelectedTagsComponent_ng_template_8_button_3_Template, 2, 4, "button", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tag_r19 = ctx.tag;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6, !ctx_r5.removable));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r5.hasSquareElement);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", tag_r19.text)("title", tag_r19.ellipsisText);
    i0.ɵɵattribute("aria-label", tag_r19.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r5.removable);
  }
}
function SelectedTagsComponent_ng_template_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r30 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const _r6 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, item_r30));
  }
}
function SelectedTagsComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, SelectedTagsComponent_ng_template_10_div_1_Template, 2, 4, "div", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r7.hiddenItems);
  }
}
const _c7 = a0 => ({
  "custom-max-items": a0
});
class SelectedTagsComponent {
  constructor(domSanitizer, changeDetectionRef) {
    this.domSanitizer = domSanitizer;
    this.changeDetectionRef = changeDetectionRef;
    /**
     * User can set maximum number of displayed tags to be a very large number. In order to avoid
     * displaying many tags on clutter the DOM, we set an inner maximum value of tags.
     * The display value will be the minimum between the user supplied value and this value.
     */
    this.MAX_ALLOWED_TAGS_TO_DISPLAY = 10;
    this.tagsSource = [];
    /**
     * Selects the unique identifier property of the object in the collection tagsSource
     */
    this.primaryKey = 'id';
    /**
     * Selects the string property of the object which is to be displayed
     */
    this.label = 'text';
    /**
     * Identifies the parent of the popup container so it will be connected to it when scrolling
     */
    this.popUpContainer = 'body';
    /**
     * event to be triggered when there is change in tagsSource
     */
    this.tagsChanged = new EventEmitter();
    /**
     * event to be triggered when the 'x more...' button is clicked.
     */
    this.viewMoreClicked = new EventEmitter();
    /**
     * event to be triggered when a tag is removed
     */
    this.tagDeleted = new EventEmitter();
    /**
     * reference to hidden items rendered for calculation of width
     */
    this.invisibleItemsRef = new QueryList();
    this.svgIcons = new SvgIcons(this.domSanitizer);
    this.visibleItems = [];
    this.hiddenItems = [];
    this.removable = this.removable !== undefined ? this.removable : false;
    this.hasSquareElement = this.hasSquareElement !== undefined ? this.hasSquareElement : false;
  }
  /* This function removes tags from selected tags array */
  removeItem(tag) {
    const indexFound = this.tagsSource.findIndex(x => '' + x[this.primaryKey] === tag.primaryValue);
    const tagToBeDeleted = this.tagsSource.find(x => '' + x[this.primaryKey] === tag.primaryValue);
    if (indexFound > -1) {
      this.tagsSource.splice(indexFound, 1);
      this.tagsChanged.emit({
        tags: this.tagsSource
      });
      this.tagDeleted.emit(tagToBeDeleted);
      this.changeDetectionRef.detectChanges();
      this.renderSelectedTags();
    }
  }
  prepareItemsToDisplay(items, containerWidth) {
    this.maxTagsToDisplay = Math.min(this.maxTagsToDisplay, this.MAX_ALLOWED_TAGS_TO_DISPLAY);
    if (this.maxTagsToDisplay > 0) {
      if (this.maxTagsToDisplay > items.length) {
        this.visibleItems = [...items];
        this.hiddenItems = [];
      } else {
        this.visibleItems = [...items.slice(0, this.maxTagsToDisplay)];
        this.hiddenItems = [...items.slice(this.maxTagsToDisplay, items.length)];
      }
    } else {
      this.prepareSelectedItems(items, containerWidth);
    }
  }
  /* prepares the selectedTags dynamically based on the available container width */
  prepareSelectedItems(items, containerWidth) {
    let hiddenStartIndex = -1;
    let hiddenItems = [];
    let visibleItems = [];
    const offset = 10;
    let moreWidth = 0;
    if (this.moreEleRef && this.moreEleRef.nativeElement) {
      moreWidth = this.moreEleRef.nativeElement.offsetWidth;
    }
    let remainingWidth = containerWidth - moreWidth;
    for (let i = 0; i < items.length; i += 1) {
      const itemWidth = items[i].width;
      remainingWidth = remainingWidth - itemWidth - offset;
      if (remainingWidth < 0) {
        hiddenStartIndex = i;
        if (!this.moreEleRef) {
          setTimeout(() => {
            this.prepareSelectedItems(items, containerWidth);
            this.changeDetectionRef.detectChanges();
          });
        }
        break;
      }
    }
    if (hiddenStartIndex === -1) {
      visibleItems = items;
    } else {
      visibleItems = items.slice(0, hiddenStartIndex);
      hiddenItems = items.slice(hiddenStartIndex, items.length);
    }
    this.visibleItems = [...visibleItems];
    this.hiddenItems = [...hiddenItems];
  }
  ngAfterViewInit() {
    this.renderSelectedTags();
  }
  ngOnChanges(changes) {
    if (changes.tagsSource && !changes.tagsSource.firstChange) {
      this.tagsSource = changes.tagsSource.currentValue;
      this.changeDetectionRef.detectChanges();
      this.renderSelectedTags();
    }
  }
  renderSelectedTags() {
    const containerWidth = this.tagWrapperEleRef.nativeElement.offsetWidth;
    const items = this.invisibleItemsRef.toArray().map(x => {
      return {
        width: x.nativeElement.offsetWidth,
        text: x.nativeElement.children[0].textContent,
        primaryValue: x.nativeElement.children[0].getAttribute('data-primary-value'),
        color: x.nativeElement.children[0].style.backgroundColor,
        ellipsisText: x.nativeElement.children[0].scrollWidth > x.nativeElement.children[0].clientWidth ? x.nativeElement.children[0].textContent : '' //only if does not have ellipsis - title is empty
      };
    });
    this.prepareItemsToDisplay(items, containerWidth);
    this.changeDetectionRef.detectChanges();
  }
  styleBackgroundColor() {
    const popoverEl = document.querySelector('body > .popover');
    if (popoverEl != null && this.popoverBackgroundColor !== undefined) {
      popoverEl.style.backgroundColor = this.popoverBackgroundColor;
    }
  }
  onResizeContainer(_event) {
    this.renderSelectedTags();
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SelectedTagsComponent_Factory(t) {
      return new (t || SelectedTagsComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SelectedTagsComponent,
      selectors: [["cxone-selected-tags"]],
      viewQuery: function SelectedTagsComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.moreEleRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tagWrapperEleRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invisibleItemsRef = _t);
        }
      },
      inputs: {
        tagsSource: "tagsSource",
        removable: "removable",
        hasSquareElement: "hasSquareElement",
        popoverBackgroundColor: "popoverBackgroundColor",
        primaryKey: "primaryKey",
        label: "label",
        popUpContainer: "popUpContainer",
        maxTagsToDisplay: "maxTagsToDisplay",
        tagsHeaderTemplate: "tagsHeaderTemplate"
      },
      outputs: {
        tagsChanged: "tagsChanged",
        viewMoreClicked: "viewMoreClicked",
        tagDeleted: "tagDeleted"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 12,
      vars: 7,
      consts: [[1, "cxone-selected-tags", 3, "resized"], [1, "cxone-tags-wrapper"], ["tagWrapperEleRef", ""], [1, "cxone-tags", 3, "ngClass"], [4, "ngIf"], ["class", "horizontal", 4, "ngFor", "ngForOf"], ["class", "cxone-more", 3, "click", 4, "ngIf"], ["class", "cxone-tag-container invisible", 4, "ngFor", "ngForOf"], ["tagTemplate", ""], ["hiddenItemsPopover", ""], [4, "ngTemplateOutlet"], [1, "horizontal"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cxone-more", 3, "click"], ["moreEleRef", ""], [3, "popover", "containerClass", "placement", "outsideClick", "container", "onShown"], [1, "cxone-tag-container", "invisible"], ["invisibleItemEleRef", ""], [1, "cxone-tag", 3, "innerText"], ["class", "close-tag", "aria-label", "remove filter", 3, "innerHTML", 4, "ngIf"], [3, "ngStyle", 4, "ngIf"], ["aria-label", "remove filter", 1, "close-tag", 3, "innerHTML"], [3, "ngStyle"], [1, "cxone-tag-container", 3, "ngClass"], [1, "cxone-tag", 3, "innerText", "title"], ["class", "close-tag", 3, "innerHTML", "click", "keydown.enter", 4, "ngIf"], [1, "close-tag", 3, "innerHTML", "click", "keydown.enter"], [1, "content"], ["class", "vertical", 4, "ngFor", "ngForOf"], [1, "vertical"]],
      template: function SelectedTagsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("resized", function SelectedTagsComponent_Template_div_resized_0_listener($event) {
            return ctx.onResizeContainer($event);
          });
          i0.ɵɵelementStart(1, "div", 1, 2)(3, "div", 3);
          i0.ɵɵtemplate(4, SelectedTagsComponent_div_4_Template, 2, 1, "div", 4)(5, SelectedTagsComponent_div_5_Template, 2, 4, "div", 5)(6, SelectedTagsComponent_div_6_Template, 6, 13, "div", 6);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, SelectedTagsComponent_div_7_Template, 5, 7, "div", 7)(8, SelectedTagsComponent_ng_template_8_Template, 4, 8, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(10, SelectedTagsComponent_ng_template_10_Template, 2, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c7, !!ctx.maxTagsToDisplay));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.tagsHeaderTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.visibleItems);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.hiddenItems.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.tagsSource);
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, i3.ResizeEventDirective, i4.PopoverDirective, i5.TranslationPipe],
      styles: [".cxone-tag{color:#2e2e2e;font-size:13px;line-height:13px;height:16px;max-width:100px;min-width:40px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-family:OpenSans;margin-top:3px;margin-bottom:-1px}.cxone-selected-tags{width:100%;min-width:100px}.cxone-selected-tags .cxone-tags-wrapper{width:100%;overflow:hidden;display:flex;align-items:center}.cxone-selected-tags .cxone-tags-wrapper .cxone-tags{display:flex;align-items:center;flex-wrap:nowrap}.cxone-selected-tags .cxone-tags-wrapper .cxone-tags.custom-max-items{flex-wrap:wrap}.cxone-selected-tags .cxone-tags-wrapper .cxone-tags .horizontal{display:inline-block}.cxone-selected-tags .cxone-tags-wrapper .cxone-more{padding-left:5px;text-align:left;font-family:OpenSans;letter-spacing:0;opacity:1;font-size:13px}.cxone-selected-tags .cxone-tags-wrapper .cxone-more button{text-decoration:none;color:#007cbe;cursor:pointer;white-space:nowrap;background-color:transparent;border:transparent}.cxone-selected-tags .cxone-tag-container{border-radius:3px;border:1px solid rgb(218,226,232);box-sizing:border-box;background-color:#fff;margin:2px 5px;padding:0 6px;overflow:hidden;display:flex;align-items:center;justify-content:space-between;min-width:80px;height:26px;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cxone-selected-tags .cxone-tag-container.non-removable{justify-content:center}.cxone-selected-tags .cxone-tag-container.invisible,.cxone-selected-tags .cxone-tag-container .itemId{visibility:hidden;position:absolute}.cxone-selected-tags .cxone-tag-container .close-tag{background-color:transparent;border:transparent;padding:5px 0 0;font-size:16px}.cxone-selected-tags .cxone-tag-container .close-tag svg{width:14px;height:14px;cursor:pointer;margin-left:8px;fill:#526b7a}.cxone-selected-tags .cxone-tag-container .close-tag:hover{text-decoration:none}.popover.cxone-selected-tags-popover{border-radius:0;border:1px solid #D0D2D3;box-shadow:none;max-width:250px}.popover.cxone-selected-tags-popover .popover-content{padding:10px;max-height:250px;overflow:auto}.popover.cxone-selected-tags-popover .popover-arrow{display:none}.popover.cxone-selected-tags-popover .vertical{display:table;margin-bottom:10px}.popover.cxone-selected-tags-popover .cxone-tag-container{border-radius:3px;border:1px solid rgb(218,226,232);box-sizing:border-box;background-color:#fff;margin:2px 5px;padding:4px 6px;overflow:hidden;display:flex;align-items:center;justify-content:space-between;min-width:80px;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.popover.cxone-selected-tags-popover .cxone-tag-container.invisible{visibility:hidden;position:absolute}.popover.cxone-selected-tags-popover .cxone-tag-container .close-tag{background-color:transparent;border:transparent}.popover.cxone-selected-tags-popover .cxone-tag-container .close-tag svg{width:14px;height:14px;cursor:pointer;margin-left:8px;margin-top:8px;fill:#526b7a}.popover.cxone-selected-tags-popover .cxone-tag-container .close-tag:hover{text-decoration:none}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedTagsComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-selected-tags',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"cxone-selected-tags\" (resized)=\"onResizeContainer($event)\">\n  <div class=\"cxone-tags-wrapper\" #tagWrapperEleRef>\n    <div class=\"cxone-tags\" [ngClass]=\"{'custom-max-items': !!maxTagsToDisplay}\">\n      <div *ngIf=\"tagsHeaderTemplate\">\n        <ng-container *ngTemplateOutlet=\"tagsHeaderTemplate\"></ng-container>\n      </div>\n      <div class=\"horizontal\" *ngFor=\"let item of visibleItems\">\n        <ng-container [ngTemplateOutlet]=\"tagTemplate\" [ngTemplateOutletContext]=\"{tag: item}\"></ng-container>\n      </div>\n      <div class=\"cxone-more\" #moreEleRef *ngIf=\"hiddenItems.length > 0\" (click)=\"viewMoreClicked.emit()\">\n      <button [popover]=\"hiddenItemsPopover\" [containerClass]=\"'cxone-selected-tags-popover custom-tags-class'\" [placement]=\"'bottom'\" [outsideClick]=\"true\" [attr.container]=\"popUpContainer\" [container]=\"popUpContainer\"\n         (onShown)=\"styleBackgroundColor()\" [attr.aria-label]=\"hiddenItems.length +' '+('cxone-components.selectedTags.moreText' | translate)\">{{hiddenItems.length}} {{'cxone-components.selectedTags.moreText' | translate }}</button>\n      </div>\n    </div>\n  </div>\n  <div class=\"cxone-tag-container invisible\" *ngFor=\"let item of tagsSource\" #invisibleItemEleRef>\n    <div class=\"cxone-tag\" [attr.aria-label]=\"item[label]\" [attr.data-primary-value]=\"item[primaryKey]\" [innerText]=\"item[label]\" [style.background-color]=\"item['color']\"></div>\n    <button *ngIf=\"removable\" class=\"close-tag\" [innerHTML]=\"svgIcons.getSvgIcons('icon-close')\" aria-label=\"remove filter\"></button>\n    <div *ngIf=\"hasSquareElement\" [ngStyle]=\"{'background-color': 'white', 'height': '10px', 'width':'10px', 'margin-right':'5px'}\"></div>\n  </div>\n  <ng-template #tagTemplate let-tag=\"tag\">\n    <div class=\"cxone-tag-container\" [ngClass]=\"{ 'non-removable': !removable }\">\n      <div *ngIf=\"hasSquareElement\" [ngStyle]=\"{'background-color': tag.color, 'height': '10px', 'width':'10px', 'margin-right':'5px'}\"></div>\n      <div class=\"cxone-tag\" [attr.aria-label]=\"tag.text\" [innerText]=\"tag.text\" [title]=\"tag.ellipsisText\"></div>\n        <button *ngIf=\"removable\" class=\"close-tag\" [innerHTML]=\"svgIcons.getSvgIcons('icon-close')\"  \n          [attr.aria-label]=\"('cxone-components.selectedTags.remove' | translate) + tag.text\"\n          (click)=\"removeItem(tag)\" (keydown.enter)=\"removeItem(tag)\">\n        </button>\n    </div>\n  </ng-template>\n  <ng-template #hiddenItemsPopover>\n    <div class=\"content\">\n      <div class=\"vertical\" *ngFor=\"let item of hiddenItems\">\n        <ng-container [ngTemplateOutlet]=\"tagTemplate\" [ngTemplateOutletContext]=\"{tag: item}\"></ng-container>\n      </div>\n    </div>\n  </ng-template>\n</div>\n",
      styles: [".cxone-tag{color:#2e2e2e;font-size:13px;line-height:13px;height:16px;max-width:100px;min-width:40px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-family:OpenSans;margin-top:3px;margin-bottom:-1px}.cxone-selected-tags{width:100%;min-width:100px}.cxone-selected-tags .cxone-tags-wrapper{width:100%;overflow:hidden;display:flex;align-items:center}.cxone-selected-tags .cxone-tags-wrapper .cxone-tags{display:flex;align-items:center;flex-wrap:nowrap}.cxone-selected-tags .cxone-tags-wrapper .cxone-tags.custom-max-items{flex-wrap:wrap}.cxone-selected-tags .cxone-tags-wrapper .cxone-tags .horizontal{display:inline-block}.cxone-selected-tags .cxone-tags-wrapper .cxone-more{padding-left:5px;text-align:left;font-family:OpenSans;letter-spacing:0;opacity:1;font-size:13px}.cxone-selected-tags .cxone-tags-wrapper .cxone-more button{text-decoration:none;color:#007cbe;cursor:pointer;white-space:nowrap;background-color:transparent;border:transparent}.cxone-selected-tags .cxone-tag-container{border-radius:3px;border:1px solid rgb(218,226,232);box-sizing:border-box;background-color:#fff;margin:2px 5px;padding:0 6px;overflow:hidden;display:flex;align-items:center;justify-content:space-between;min-width:80px;height:26px;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cxone-selected-tags .cxone-tag-container.non-removable{justify-content:center}.cxone-selected-tags .cxone-tag-container.invisible,.cxone-selected-tags .cxone-tag-container .itemId{visibility:hidden;position:absolute}.cxone-selected-tags .cxone-tag-container .close-tag{background-color:transparent;border:transparent;padding:5px 0 0;font-size:16px}.cxone-selected-tags .cxone-tag-container .close-tag svg{width:14px;height:14px;cursor:pointer;margin-left:8px;fill:#526b7a}.cxone-selected-tags .cxone-tag-container .close-tag:hover{text-decoration:none}.popover.cxone-selected-tags-popover{border-radius:0;border:1px solid #D0D2D3;box-shadow:none;max-width:250px}.popover.cxone-selected-tags-popover .popover-content{padding:10px;max-height:250px;overflow:auto}.popover.cxone-selected-tags-popover .popover-arrow{display:none}.popover.cxone-selected-tags-popover .vertical{display:table;margin-bottom:10px}.popover.cxone-selected-tags-popover .cxone-tag-container{border-radius:3px;border:1px solid rgb(218,226,232);box-sizing:border-box;background-color:#fff;margin:2px 5px;padding:4px 6px;overflow:hidden;display:flex;align-items:center;justify-content:space-between;min-width:80px;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.popover.cxone-selected-tags-popover .cxone-tag-container.invisible{visibility:hidden;position:absolute}.popover.cxone-selected-tags-popover .cxone-tag-container .close-tag{background-color:transparent;border:transparent}.popover.cxone-selected-tags-popover .cxone-tag-container .close-tag svg{width:14px;height:14px;cursor:pointer;margin-left:8px;margin-top:8px;fill:#526b7a}.popover.cxone-selected-tags-popover .cxone-tag-container .close-tag:hover{text-decoration:none}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i0.ChangeDetectorRef
  }], {
    tagsSource: [{
      type: Input
    }],
    removable: [{
      type: Input
    }],
    hasSquareElement: [{
      type: Input
    }],
    popoverBackgroundColor: [{
      type: Input
    }],
    primaryKey: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    popUpContainer: [{
      type: Input
    }],
    maxTagsToDisplay: [{
      type: Input
    }],
    tagsHeaderTemplate: [{
      type: Input
    }],
    tagsChanged: [{
      type: Output
    }],
    viewMoreClicked: [{
      type: Output
    }],
    tagDeleted: [{
      type: Output
    }],
    moreEleRef: [{
      type: ViewChild,
      args: ['moreEleRef', {
        static: false
      }]
    }],
    tagWrapperEleRef: [{
      type: ViewChild,
      args: ['tagWrapperEleRef', {
        static: false
      }]
    }],
    invisibleItemsRef: [{
      type: ViewChildren,
      args: ['invisibleItemEleRef']
    }]
  });
})();
class SelectedTagsModule {
  /** @nocollapse */static {
    this.ɵfac = function SelectedTagsModule_Factory(t) {
      return new (t || SelectedTagsModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SelectedTagsModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ResizeEventModule, PopoverModule.forRoot(), TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedTagsModule, [{
    type: NgModule,
    args: [{
      declarations: [SelectedTagsComponent],
      exports: [SelectedTagsComponent],
      imports: [CommonModule, ResizeEventModule, PopoverModule.forRoot(), TranslationModule]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SelectedTagsComponent, SelectedTagsModule };
